<template>
  <div class="vheight PropertyProjectManagerDetails">
    <div
      class="header-seacher"
      v-resize="redraw"
      :inline="true"
      style="border-bottom: 0px dotted #797979"
    >
      <el-tabs
        style="margin-top: 10px"
        type="border-card"
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane :label="title" name="first"></el-tab-pane>
        <!-- <el-tab-pane v-if="isProjectManager" label="良好业绩" name="second"></el-tab-pane>
        <el-tab-pane v-if="isProjectManager" label="表彰信息" name="third"></el-tab-pane>
        <el-tab-pane v-if="isProjectManager" label="不良行为" name="four"></el-tab-pane>
        <el-tab-pane v-if="isProjectManager" label="行政处罚" name="five"></el-tab-pane> -->
      </el-tabs>
    </div>

    <div
      class="container"
      :style="{ height: 'calc(95%)' }"
      style="padding-left: 10px; padding-right: 10px"
    >
      <div
        :key="key"
        class="PublicInformationDetail"
        v-show="activeName === 'first'"
        style="padding-left: 0px; padding-right: 0px; background: white"
      >
        <div
          v-if="isProjectManager"
          class="basInfo-table"
          :style="{ height: 'calc(100% - -3px)' }"
          v-loading="loading"
          element-loading-text="数据正在加载中，请稍候"
        >
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">姓名</div>
            <div class="col-define col-xs-4 col-md-4">
              {{ EmployeeDetail.FullName || '--' }}
            </div>
            <div class="col-define col-tips col-xs-2 col-md-2">性别</div>
            <div class="col-define col-xs-4 col-md-4">
              {{ EmployeeDetail.Gender || '--' }}
            </div>
            <!-- <div class="col-define col-tips col-xs-2 col-md-2">办公电话</div>
            <div class="col-define col-xs-4 col-md-4">{{EmployeeDetail.Tel}}</div> -->
          </div>
          <div class="row">
            <!-- <div class="col-define col-tips col-xs-2 col-md-2">证件号码</div>
            <div class="col-define col-xs-4 col-md-4">{{EmployeeDetail.IDCardNumber}}</div> -->
            <div class="col-define col-tips col-xs-2 col-md-2">
              物业企业名称
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{ EmployeeDetail.OrgCodeName || '--' }}
            </div>
            <div class="col-define col-tips col-xs-2 col-md-2">学历</div>
            <div class="col-define col-xs-4 col-md-4">
              {{
                (EmployeeDetail.Education &&
                  eductionType[0][EmployeeDetail.Education]) ||
                '--'
              }}
            </div>
          </div>
          <!-- <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">移动电话</div>
            <div class="col-define col-xs-4 col-md-4">{{EmployeeDetail.MobilePhone}}</div>

          </div> -->
          <!-- <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">联系地址</div>
            <div class="col-define col-xs-4 col-md-4">{{EmployeeDetail.Address}}</div>
            <div class="col-define col-tips col-xs-2 col-md-2">人员类型</div>
            <div
              v-if="EmployeeDetail.EmployeeType"
              class="col-define col-xs-4 col-md-4"
            >{{EmployeeDetail.EmployeeType && peopleType[0][EmployeeDetail.EmployeeType]}}</div>
            <div v-if="!EmployeeDetail.EmployeeType" class="col-define col-xs-4 col-md-4"></div>
          </div> -->
          <div class="row">
            <!-- <div class="col-define col-tips col-xs-2 col-md-2">出生日期</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{EmployeeDetail.BirthDay | formatDate('yyyy-MM-dd')}}</div> -->
            <div class="col-define col-tips col-xs-2 col-md-2">职务</div>
            <div v-if="EmployeeDetail.Job" class="col-define col-xs-4 col-md-4">
              {{
                (EmployeeDetail.Job && zwpzType[0][EmployeeDetail.Job]) || '--'
              }}
            </div>
            <div v-else class="col-define col-xs-4 col-md-4">--</div>
            <!-- </div>
          <div class="row"> -->

            <div class="col-define col-tips col-xs-2 col-md-2">职称</div>
            <div
              v-if="EmployeeDetail.MajorType"
              class="col-define col-xs-4 col-md-4"
            >
              {{
                (EmployeeDetail.MajorTypeLevel &&
                  levelType[0][EmployeeDetail.MajorTypeLevel]) ||
                '--'
              }}
            </div>
            <div
              class="col-define col-xs-4 col-md-4"
              v-if="!EmployeeDetail.MajorType"
            >
              --
            </div>
          </div>
          <!-- <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">上岗证书名称</div>
            <div class="col-define col-xs-4 col-md-4">{{EmployeeDetail.QualificationName}}</div>
            <div class="col-define col-tips col-xs-2 col-md-2">上岗证书编号</div>
            <div class="col-define col-xs-4 col-md-4">{{EmployeeDetail.QualificationCode}}</div>
          </div>

          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">从事物管年限</div>
            <div class="col-define col-xs-4 col-md-4">{{EmployeeDetail.WorkYears}}</div>
            <div class="col-define col-tips col-xs-2 col-md-2">邮箱</div>
            <div class="col-define col-xs-4 col-md-4">{{EmployeeDetail.Email}}</div>
          </div> -->

          <!-- <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">劳务合同开始日期</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{EmployeeDetail.ContractSTime | formatDate('yyyy-MM-dd')}}</div>
            <div class="col-define col-tips col-xs-2 col-md-2">劳务合同结束日期</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{EmployeeDetail.ContractETime | formatDate('yyyy-MM-dd')}}</div>
          </div> -->
          <!-- <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">从业年限</div>
            <div class="col-define col-xs-4 col-md-4">{{EmployeeDetail.WorkYears}}</div>
            <div class="col-define col-tips col-xs-2 col-md-2">业主满意度</div>
            <div class="col-define col-xs-4 col-md-4"></div>
          </div> -->
          <!-- <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">业主满意度排名</div>
            <div class="col-define col-xs-4 col-md-4"></div>
            <div class="col-define col-tips col-xs-2 col-md-2"></div>
            <div class="col-define col-xs-4 col-md-4"></div>
          </div> -->
        </div>
        <div
          v-if="!isProjectManager"
          class="basInfo-table"
          :style="{ height: 'calc(100% - -3px)' }"
        >
          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">姓名</div>
            <div class="col-define col-xs-4 col-md-4">
              {{ EmployeeDetail.FullName || '--' }}
            </div>
            <div class="col-define col-tips col-xs-2 col-md-2">性别</div>
            <div class="col-define col-xs-4 col-md-4">
              {{ EmployeeDetail.Gender || '--' }}
            </div>
          </div>

          <div class="row">
            <!-- <div class="col-define col-tips col-xs-2 col-md-2">证件号码</div>
            <div class="col-define col-xs-4 col-md-4">{{EmployeeDetail.IDCardNumber}}</div> -->
            <div class="col-define col-tips col-xs-2 col-md-2">
              物业企业名称
            </div>
            <div class="col-define col-xs-4 col-md-4">
              {{ EmployeeDetail.OrgCodeName || '--' }}
            </div>
            <div class="col-define col-tips col-xs-2 col-md-2">学历</div>
            <div class="col-define col-xs-4 col-md-4">
              {{
                (EmployeeDetail.Education &&
                  eductionType[0][EmployeeDetail.Education]) ||
                '--'
              }}
            </div>
          </div>

          <!-- <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">联系地址</div>
            <div class="col-define col-xs-4 col-md-4">{{EmployeeDetail.Address}}</div>
            <div class="col-define col-tips col-xs-2 col-md-2">人员类型</div>
            <div
              v-if="EmployeeDetail.EmployeeType"
              class="col-define col-xs-4 col-md-4"
            >{{EmployeeDetail.EmployeeType && peopleType[0][EmployeeDetail.EmployeeType]}}</div>
            <div v-if="!EmployeeDetail.EmployeeType" class="col-define col-xs-4 col-md-4"></div>
          </div> -->

          <div class="row">
            <!-- <div class="col-define col-tips col-xs-2 col-md-2">出生日期</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{EmployeeDetail.BirthDay | formatDate('yyyy-MM-dd')}}</div> -->
            <div class="col-define col-tips col-xs-2 col-md-2">职务</div>
            <div v-if="EmployeeDetail.Job" class="col-define col-xs-4 col-md-4">
              {{
                (EmployeeDetail.Job && zwpzType[0][EmployeeDetail.Job]) || '--'
              }}
            </div>
            <div v-else class="col-define col-xs-4 col-md-4">--</div>
            <!-- </div>

          <div class="row"> -->
            <div class="col-define col-tips col-xs-2 col-md-2">职称</div>
            <div
              v-if="EmployeeDetail.MajorType"
              class="col-define col-xs-4 col-md-4"
            >
              {{
                (EmployeeDetail.MajorType &&
                  levelType[0][EmployeeDetail.MajorType]) ||
                '--'
              }}
            </div>
            <div
              v-if="!EmployeeDetail.MajorType"
              class="col-define col-xs-4 col-md-4"
            ></div>
            <!-- <div class="col-define col-tips col-xs-2 col-md-2">职称等级</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{EmployeeDetail.MajorTypeLeve && levelType[0][EmployeeDetail.MajorTypeLevel]}}</div> -->
          </div>

          <!-- <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">上岗证书名称</div>
            <div class="col-define col-xs-4 col-md-4">{{EmployeeDetail.QualificationName}}</div>
            <div class="col-define col-tips col-xs-2 col-md-2">上岗证书编号</div>
            <div class="col-define col-xs-4 col-md-4">{{EmployeeDetail.QualificationCode}}</div>
          </div>

          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">从事物管年限</div>
            <div class="col-define col-xs-4 col-md-4">{{EmployeeDetail.WorkYears}}</div>
            <div class="col-define col-tips col-xs-2 col-md-2">邮箱</div>
            <div class="col-define col-xs-4 col-md-4">{{EmployeeDetail.Email}}</div>
          </div>

          <div class="row">
            <div class="col-define col-tips col-xs-2 col-md-2">劳务合同开始日期</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{EmployeeDetail.ContractSTime | formatDate('yyyy-MM-dd')}}</div>
            <div class="col-define col-tips col-xs-2 col-md-2">劳务合同结束日期</div>
            <div
              class="col-define col-xs-4 col-md-4"
            >{{EmployeeDetail.ContractETime | formatDate('yyyy-MM-dd')}}</div>
          </div> -->
          <!-- <div class="row">
        <div class="col-define col-tips col-md-4">劳务合同结束日期</div>
        <div
          class="col-define col-md-8"
        >{{EmployeeDetail.ContractETime | formatDate('yyyy-MM-dd hh:mm:ss')}}</div>
          </div>-->
        </div>
      </div>
      <!-- second show -->
      <div v-show="activeName === 'second'" class="grid">
        <el-table
          ref="multipleTable"
          :data="creditData"
          tooltip-effect="dark"
          style="width: 100%"
          height="100%"
          stripe
          border
        >
          <el-table-column
            label="序号"
            width="60"
            type="index"
            v-bind:index="indexMethod"
            align="center"
            fixed
          ></el-table-column>
          <el-table-column
            label="项目名称"
            prop="EaAreaName"
            show-overflow-tooltip
            header-align="center"
            align="left"
            fixed
          ></el-table-column>
          <el-table-column
            label="物业类别"
            width="100"
            prop="EaAreaType"
            show-overflow-tooltip
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.EaAreaType">{{
                scope.row.EaAreaType && type[0][scope.row.EaAreaType]
              }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="物业类别" header-align="center" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.EaAreaType && type[0][scope.row.EaAreaType+1] }}</span>
            </template>
          </el-table-column>-->

          <el-table-column
            label="项目地址"
            prop="Address"
            show-overflow-tooltip
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            label="建筑面积"
            width="150"
            prop="BuildArea"
            show-overflow-tooltip
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            label="项目评价标识"
            width="150"
            prop="EvaluateSign"
            show-overflow-tooltip
            header-align="center"
            align="center"
          ></el-table-column>
        </el-table>
      </div>
      <!--  -->
      <div v-show="activeName === 'third'" class="grid">
        <el-table
          ref="multipleTable"
          :data="creditData"
          tooltip-effect="dark"
          style="width: 100%"
          height="100%"
          stripe
          border
        >
          <el-table-column
            label="序号"
            width="60"
            type="index"
            v-bind:index="indexMethod"
            align="center"
            fixed
          ></el-table-column>
          <el-table-column
            label="表彰名称"
            prop="ActionName"
            show-overflow-tooltip
            header-align="center"
            align="left"
            fixed
          ></el-table-column>
          <el-table-column
            label="表彰等级"
            width="180"
            prop="ActionLevel"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            label="表彰类别"
            width="180"
            prop="ActionType"
            show-overflow-tooltip
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            label="获得时间"
            width="150"
            prop="ActionDate"
            show-overflow-tooltip
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.ActionDate | formatDate('yyyy-MM-dd') }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--  -->
      <div v-show="activeName === 'four'" class="grid">
        <el-table
          ref="multipleTable"
          :data="creditData"
          tooltip-effect="dark"
          style="width: 100%"
          height="100%"
          stripe
          border
        >
          <el-table-column
            label="序号"
            width="60"
            type="index"
            v-bind:index="indexMethod"
            align="center"
            fixed
          ></el-table-column>
          <el-table-column
            label="行为概述"
            prop="ActionSummary"
            show-overflow-tooltip
            header-align="center"
            align="left"
            fixed
          ></el-table-column>
          <el-table-column
            label="详细描述"
            prop="ActionDetailSummary"
            header-align="center"
            align="left"
          ></el-table-column>

          <!-- <el-table-column
            label="判决时间"
            prop="ActionDate"
            width="150"
            show-overflow-tooltip
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.ActionDate|formatDate('yyyy-MM-dd') }}</span>
            </template>
          </el-table-column>-->
        </el-table>
      </div>
      <!--  -->
      <div v-show="activeName === 'five'" class="grid">
        <el-table
          ref="multipleTable"
          :data="creditData"
          tooltip-effect="dark"
          style="width: 100%"
          height="100%"
          stripe
          border
        >
          <el-table-column
            label="序号"
            width="60"
            type="index"
            v-bind:index="indexMethod"
            align="center"
            fixed
          ></el-table-column>
          <el-table-column
            label="文号"
            width="180"
            prop="ActionFileNum"
            show-overflow-tooltip
            header-align="center"
            align="center"
            fixed
          ></el-table-column>
          <el-table-column
            label="违法行为"
            prop="ActionSummary"
            header-align="center"
            align="left"
          ></el-table-column>
          <el-table-column
            label="处罚种类"
            width="150"
            prop="ActionType"
            show-overflow-tooltip
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            label="处罚单位"
            min-width="150"
            prop="ActionOrg"
            show-overflow-tooltip
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            label="判决时间"
            prop="ActionDate"
            width="150"
            show-overflow-tooltip
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.ActionDate | formatDate('yyyy-MM-dd') }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            label="处罚时间"
            width="200"
            prop="PropertyManagerTel"
            show-overflow-tooltip
            header-align="center"
            align="center"
          ></el-table-column>-->
        </el-table>
      </div>
    </div>
    <div v-show="activeName != 'first'" class="footer">
      <div class="page">
        <ps-page
          :page="page"
          @getData="
            activeName == 'third' ? getPrejectDetailData() : etEmployeeData()
          "
        ></ps-page>
      </div>
    </div>
    <!-- <div class="PublicInformationDetail-footer">
      <ps-close></ps-close>
    </div>-->
  </div>
</template>

<script>
import { PropertyProjectControllerSvr } from '@/service/PropertyProjectControllerSvr/PropertyProjectControllerSvr.js';
import { CommitteeInfoControllerSvr } from '@/service/CommitteeInfoControllerSvr/CommitteeInfoControllerSvr.js';
import { BuildUnitInfoControllerSvr } from '@/service/BuildUnitInfoControllerSvr/BuildUnitInfoControllerSvr.js';
import { OrgBaseMgmtControllerSvr } from '@/service/OrgBaseMgmtControllerSvr.js';
import { CommonControllerSvr } from '@/service/CommonControllerSvr/CommonControllerSvr.js';
import {
  registrationType,
  holdingSituation,
  licenseLevel,
  accountingType,
  organizationType,
  companyType,
  ProjecType,
} from '@/enum/propertyEnterprise.js';
import { OpenControllerSvr } from '@/service/OpenControllerSvr/OpenControllerSvr.js';
import { headerredraw } from '@/mixin/headerredraw';
import { Page } from '@/models/page';
import { EnumController } from '@/service/EnumController/EnumController.js';
import { mapState, mapActions, mapMutations } from 'vuex';
export default {
  name: 'EmployeeDetailInformation',
  metaInfo: {
    title: '业主大会和业委会查询',
    meta: [
      {
        name: 'viewport',
        content:
          'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no',
      },
      { name: 'SiteName', content: '深圳市住房和建设局网站' },
      { name: 'SiteDomain', content: 'zjj.sz.gov.cn' },
      { name: 'SiteIDCode', content: '4403000005' },
      { name: 'ColumnName', content: '物业管理政策专题' },
      {
        name: 'ColumnDescription',
        content: '该栏目公布物业管理政策专栏的信息。',
      },
      { name: 'ColumnKeywords', content: '物业管理政策专栏' },
      { name: 'ColumnType', content: '其他' },
    ],
  },
  components: {},
  props: {},
  mixins: [headerredraw],
  data() {
    return {
      key: 0,
      title: '人员基本信息', //以前默认是（从业人员详情）
      isProjectManager: false,
      EmployeeDetail: {},
      creditData: [],
      PrejectData: [],
      type: [],
      activeName: 'first',
      page: new Page(),
      keyWords: '',
      dialogVisible: false,
      orgCode: '',
      employeeNumber: '',
      userType: 0,
      eaAreaCode: '',
      keyID: '',
      projectDetailsID: '',
      ProjectDetail: {},
      RealtyMgeComDetail: {},
      OwnerCommittee: {},
      Employee: {},
      BuildUnit: '',
      projecType: new ProjecType(),
      PertyMgeInfo: '',
      holdingSituation: new holdingSituation(),
      licenseLevel: new licenseLevel(),
      accountingType: new accountingType(),
      organizationType: new organizationType(),
      companyType: new companyType(),
      AllTypeArray: [],
      zwpzType: [],
      eductionType: [],
      zyflType: [],
      levelType: [],
      peopleType: [],
      ZCType: [],
      paraNameArray: [
        '职务配置',
        '最高学历配置',
        '专业分类配置',
        '专业分类等级配置',
        '人员类型配置',
      ],
      loading: false,
    };
  },
  watch: {
    userType: {
      handler() {
        // this.title = "项目负责人详情";
        this.isProjectManager = true;
      },
    },
  },
  computed: {
    ...mapState(['token', 'tabsRouter']),
  },
  created() {
    this.OpenControllerSvr = new OpenControllerSvr();
    if (this.$route.query.userType == '11') {
      // this.title = "项目负责人详情";
      this.isProjectManager = true;
    }
    this.EnumController = new EnumController();
    this.BuildUnitInfoControllerSvr = new BuildUnitInfoControllerSvr();
    this.OrgBaseMgmtControllerSvr = new OrgBaseMgmtControllerSvr();
    this.PropertyProjectControllerSvr = new PropertyProjectControllerSvr();
    this.CommitteeInfoControllerSvr = new CommitteeInfoControllerSvr();
    this.CommonControllerSvr = new CommonControllerSvr();
    this.getAllType(this.paraNameArray);
  },
  mounted() {
    this.orgCode = this.$route.query.orgCode;
    this.employeeNumber = this.$route.query.employeeNumber;
    this.userType = this.$route.query.userType;

    this.getEmployeeDetail();
  },
  methods: {
    ...mapActions({
      DeleTabsRouter: 'DeleTabsRouter',
    }),
    indexMethod(index) {
      return index + 1 + (this.page.currentPage - 1) * this.page.currtNum;
    },
    handleClick(tab, event) {
      if (tab.name === 'second') {
        this.getEnumdata('fixf.core.common.EPropertyType', '1');
      }
      if (tab.name === 'third') {
        this.getEnumdata('fixf.core.common.EPropertyType', '2');
      }
      if (tab.name === 'four') {
        this.getEnumdata('fixf.core.common.EPropertyType', '7');
      }
      if (tab.name === 'five') {
        this.getEnumdata('fixf.core.common.EPropertyType', '5');
      }
    },
    getEnumdata(name, int) {
      this.type = [];
      let temporary;
      this.EnumController.getEnum(name, false).then((res) => {
        //this.type = res;
        temporary = [...[]];
        temporary[0] = '';
        for (let { label: label, value: value } of res) {
          temporary[value] = label;
        }
        this.type.push(temporary);
        this.getCreditData(int);
      });
    },

    getCreditData(specificType) {
      this.OpenControllerSvr.queryIntegrityInfo(
        this.employeeNumber,
        2,
        specificType,
        (this.page.currentPage - 1) * this.page.currtNum,
        this.page.currtNum
      )
        .then((res) => {
          this.creditData = res._Items;
          this.page.getCurrtNum = res.TotalCount;
        })
        .catch((err) => {
          this.$message({
            message: err,
            type: 'error',
          });
        });
    },

    //获取用户详情
    getEmployeeDetail() {
      this.loading = true;
      this.OpenControllerSvr.getEmployeeDetail(
        this.$route.query.employeeNumber,
        true
      )
        .then(
          (res) => {
            this.loading = false;
            this.EmployeeDetail = res;
            this.EmployeeDetail.IDCardNumber =
              this.EmployeeDetail.IDCardNumber.substr(0, 3) +
              '*****' +
              this.EmployeeDetail.IDCardNumber.substr(
                this.EmployeeDetail.IDCardNumber.length - 3
              );
            this.EmployeeDetail.MobilePhone =
              this.EmployeeDetail.MobilePhone.substr(0, 3) +
              '****' +
              this.EmployeeDetail.MobilePhone.substr(7);
            this.key++;
          },
          (err) => {
            this.loading = false;
            this.$message({
              message: err,
              type: 'error',
            });
          }
        )
        .catch(() => {
          this.loading = false;
        });
    },

    //获取职务配置
    getzwpzType() {
      this.CommonControllerSvr.GetConfigValueList(this.paraNameArray[0]).then(
        (res) => {
          var temporary = [...[]];
          temporary[0] = '1';
          for (let { Key: key, Value: value } of res) {
            temporary[value] = key;
          }
          this.zwpzType.push(temporary);
        }
      );
    },
    //最高学历配置
    getEductionType() {
      this.CommonControllerSvr.GetConfigValueList(this.paraNameArray[1]).then(
        (res) => {
          var temporary = [...[]];
          temporary[0] = '1';
          for (let { Key: key, Value: value } of res) {
            temporary[value] = key;
          }
          this.eductionType.push(temporary);
        }
      );
    },
    //获取专业分类配置
    getzyflType() {
      this.CommonControllerSvr.GetConfigValueList(this.paraNameArray[2]).then(
        (res) => {
          var temporary = [...[]];
          temporary[0] = '1';
          for (let { Key: key, Value: value } of res) {
            temporary[value] = key;
          }
          this.zyflType.push(temporary);
        }
      );
    },
    //获取专业分类等级配置
    getlevelType() {
      this.CommonControllerSvr.GetConfigValueList(this.paraNameArray[3]).then(
        (res) => {
          var temporary = [...[]];
          temporary[0] = '1';
          for (let { Key: key, Value: value } of res) {
            temporary[value] = key;
          }
          this.levelType.push(temporary);
        }
      );
    },
    getPeopleType() {
      this.CommonControllerSvr.GetConfigValueList(this.paraNameArray[4]).then(
        (res) => {
          var temporary = [...[]];
          temporary[0] = '1';
          for (let { Key: key, Value: value } of res) {
            temporary[value] = key;
          }
          this.peopleType.push(temporary);
        }
      );
    },
    //获取所有值的类
    getAllType(paraNameArray) {
      this.getzwpzType();
      this.getEductionType();
      this.getzyflType();
      this.getlevelType();
      this.getPeopleType();
      this.EnumController.getEnum('wy.core.common.EMajorLevel').then((res) => {
        for (let item of res) {
          this.ZCType[item.value] = item.label;
        }
      });
      let temporary;
      /* paraNameArray.map((currentValue, inedx) => {
        this.CommonControllerSvr.GetConfigValueList(currentValue)
          .then(
            res => {
              temporary = [...[]];
              temporary[0] = "1";
              for (let { Key: key, Value: value } of res) {
                temporary[value] = key;
              }
              this.AllTypeArray.push(temporary);
            },
            err => {
              this.$message({
                message: err,
                type: "error"
              });
            }
          )
          .catch(() => {});
      }); */
    },
  },
};
</script>
<style lang="scss">
.PropertyProjectManagerDetails {
  .el-tabs__content {
    padding: 0px;
  }
}
</style>
<style lang="scss" scoped>
.PropertyProjectManagerDetails {
  width: 100%;
  box-sizing: border-box;
  .header-seacher {
    @media screen and (max-width: 992px) {
      min-width: 0 !important;
      overflow-x: scroll;
    }
  }
  .function {
    min-width: 400px;
  }
  .container {
    transition: height 0.3s;
    .container-header {
      width: 100%;
      padding-top: 10px;
      box-sizing: border-box;
    }
    .grid {
      height: calc(100%);
    }
  }
  .footer {
    display: flex;
    flex-direction: row-reverse;
    margin-right: 10px;
    margin-top: 20px;
    .fun {
      font-size: 14px;
      color: #409eff;
      cursor: pointer;
      .delete {
        margin-left: 20px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.PublicInformationDetail {
  height: 100%;
  width: 100%;
  .basInfo-table {
    overflow: auto;
    .row {
      margin-right: 0;
      margin-left: 0;
      @media screen and (max-width: 992px) {
        flex-wrap: wrap !important;
      }
      .col-define {
        font-size: 14px;
        line-height: 42px;
        min-width: 150px;
        overflow: hidden;
        color: #666;
        border-bottom: 1px solid #e2e2e2;
        .col-chld {
          display: inline-block;
          width: 25%;
          & > div:nth-child(1) {
            display: inline-block;
            width: 30%;
            vertical-align: top;
          }
          & > div:nth-child(2) {
            display: inline-block;
            width: 70%;
          }
        }
      }
      .col-define:nth-child(2n) {
        flex: 1;
        border-right: 1px dotted #e2e2e2;
        padding-left: 24px;
      }

      .col-define:nth-child(2n-1) {
        text-align: right;
      }

      .col-tips {
        border-right: 1px dotted #e2e2e2;
      }
    }
  }
  .PublicInformationDetail-footer {
    text-align: right;
    margin: 20px;
  }
}
.InformationDetailPropertyEnterprisesList {
  width: 100%;
  box-sizing: border-box;
  .function {
    min-width: 400px;
  }
  .container-boot {
    width: 100%;
    padding-right: 10px;
    padding-left: 10px;
    transition: height 0.3s;
    .container-header {
      width: 100%;
      padding-top: 10px;
      box-sizing: border-box;
    }
    .grid {
      height: calc(100%);
    }
  }
  .footer {
    display: flex;
    flex-direction: row-reverse;
    margin-right: 10px;
    margin-top: 20px;
    .fun {
      font-size: 14px;
      color: #409eff;
      cursor: pointer;
      .delete {
        margin-left: 20px;
      }
    }
  }
}
</style>
